import React, { Suspense } from 'react';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import UILoader from 'components/UI/Loader/Loader';

const SpotlightMismatches = React.lazy(
  () => import('components/Tools/SpotlightMismatches/SpotlightMismatches'),
);

function ScreensToolsSpotlightMismatches() {
  return (
    <BaseLayout>
      <DocumentTitle>Spotlight Mismatches</DocumentTitle>
      <UIPageTitle description="View Spotlight placement mismatches report">
        Spotlight Mismatches
      </UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <SpotlightMismatches />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsSpotlightMismatches;
